import React, { useState } from "react";
import SettingsGeneral from "./settings-general";
import SettingsIcons from "./settings-icons";
import SettingsFonts from "./settings-fonts";
import SettingsColor from "./settings-color";
import { ModalInput } from "../../ui-kit";
import Pills from "../../ui-kit/pills";

function ProjectSettings({ open, setOpen }) {
  const [activeTab, setActiveTab] = useState("project");

  const options = [
    {
      label: "Project",
      key: "project",
    },
    {
      label: "Icons",
      key: "icons",
    },
    {
      label: "Colors",
      key: "colors",
    },
  ];

  return (
    <>
      <ModalInput
        isOpened={open}
        onOutsideClick={() => {
          setOpen(false);
        }}
      >
        <div className="bg-white rounded-[21px] mw-[60vw] mh-[60vh] h-[65vh] w-[35vw] text-black">
          <div className="modal-heading p-4">Settings</div>
          <div className="flex md:gap-5 gap-2 px-4 ">
            <Pills
              options={options}
              isActive={activeTab}
              setIsActive={setActiveTab}
            />
          </div>
          <div className="h-[45vh]">
            {activeTab === "project" ? (
              <SettingsGeneral open={open} setOpen={setOpen} />
            ) : activeTab === "icons" ? (
              <SettingsIcons />
            ) : activeTab === "colors" ? (
              <SettingsColor open={open} setOpen={setOpen} />
            ) : (
              <></>
            )}
          </div>
        </div>
      </ModalInput>
    </>
  );
}

export default ProjectSettings;
